import {
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useLayoutEffect, useMemo, useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import NotificationToaste from "../global/NotificationToaste";
import MenuItemMui from "@mui/material/MenuItem";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MenuItem } from "react-pro-sidebar";
import {
  Cancel,
  Circle,
  Receipt,
  VerifiedUserSharp,
} from "@mui/icons-material";
import ConfirmationDialog from "../global/ConfirmationDialog";
import JobInvoiceDialog from "../newJob/JobInvoiceDialog";
import ReportTypeDialog from "../global/ReportTypeDialog";
import ReportDialog from "../reports/ReportDialog";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import LoadingBackDrop from "../global/LoadingBackDrop";
import { setPutPayloadWithParams } from "../../services/api";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";
import ToPanelComponent from "../toPanel/ToPanelComponent";
function CustomTabPanel({ children, value, index, ...other }) {
  // console.log("each datalogo ", data);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box justifyItems="center" sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TechnicalOfficer = ({ loggedUser }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [year, setYear] = useState([
    { id: 1, label: "2025", value: "2025" },
    { id: 2, label: "2026", value: "2026" },
  ]);
  const [officers, setOfficers] = useState([]);
  const [pendingsCreditJobs, setPendingCreditJobs] = useState([]);
  const [pendingsCreditJobsTO, setPendingCreditJobsTO] = useState([]); // for TO sajini data entering panel
  const [currentYear, setCurrentYear] = useState(2026);
  const [returnedReports, setReturnedReports] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [rejectReason, setRejectReason] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
  const [openReportDialog, setOpenReportDialog] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [openReportPreviewDialog, setOpenReportPreviewDialog] = useState(false);
  const [data, setData] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(
    "Are you sure you want to approve the report?",
  );

  const [checkedReport, setCheckedReport] = useState("APPROVE");

  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };
  //Open invoice modal

  const handleOpenInvoice = () => {
    setOpenInvoiceDialog(true);
  };

  const handleOpenReportPreview = () => {
    setOpenReportPreviewDialog(true);
  };
  const handleCloseReportPreview = () => {
    setOpenReportPreviewDialog(false);
  };

  const handleCloseInvoice = () => {
    setOpenInvoiceDialog(false);
  };

  const handleCloseReport = () => {
    setOpenReportDialog(false);
  };

  useLayoutEffect(() => {
    loadBasicData(currentYear);
  }, [message]);

  const loadBasicData = async (year) => {
    setLoading(true);
    await setPutPayloadWithParams
      .setPayloadData(
        "/labReq/all/assignedJobsTechnicalOfficer/" + loggedUser.id,
        null,
        {
          year: year,
        },
      )
      .then(function (response) {
        // const filteredArray = response.data.pendingRequests.filter(
        //   (data) => data.labRequestTests.assignUser.id == loggedUser.id
        // );
        // console.log("asd", response.data);
        setPendingCreditJobsTO(response.data.pendingRequestsTO);
        setPendingCreditJobs(response.data.pendingRequests);
        setData(response.data.submittedToEngineer);
        setReturnedReports(response.data.returnedReports);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const checkedSelectedRequestDB = async () => {
    console.log("object**********", selectedRequestId);
    setOpenConfirmDialog(false);
    setLoading(true);
    await axios
      .put(
        DATA_SAVE_URL +
          "/api/v1/labReq/checked" +
          selectedRequestId.labRequestTestId,
        null,
        {
          params: {
            userId: loggedUser.id,
            year: currentYear,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then(function (response) {
        // console.log(response.data);

        // const filteredArray = response.data.pendingRequests.filter(
        //   (data) => data.assignUser.id === loggedUser.id
        // );
        setPendingCreditJobsTO(response.data.pendingRequestsTO);
        setPendingCreditJobs(response.data.pendingRequests);
        setData(response.data.submittedToEngineer);
        setReturnedReports(response.data.returnedReports);

        setOpenConfirmDialog(false);
        setMessage("Report approved successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const unFinalizeSelectedRequestDB = async (testId) => {
    setLoading(true);
    // console.log("unfinalie ", testId);
    await axios
      .put(DATA_SAVE_URL + "/api/v1/labReq/disapproveByTo" + testId, null, {
        params: {
          userId: loggedUser.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        // console.log(response.data);

        // const filteredArray = response.data.pendingRequests.filter(
        //   (data) => data.labRequestTests.assignUser.id == loggedUser.id
        // );
        setPendingCreditJobs(response.data.pendingRequests);
        setData(response.data.submittedToEngineer);
        setReturnedReports(response.data.returnedReports);
        setMessage("Report Un-Finalized successfully..!");
        // setLoading(false);
        setMessageType("success");
        setOpen(true);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const rejectReport = async () => {
    setLoading(true);
    // console.log("unfinalie ", testId);
    await axios
      .put(
        DATA_SAVE_URL + "/api/v1/labReq/rejectReport" + selectedRequestId.id,
        null,
        {
          params: {
            userId: loggedUser.id,
            rejectReason: rejectReason,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then(function (response) {
        // console.log(response.data);
        setOpenConfirmDialog(false);
        setPendingCreditJobs(response.data.pendingRequests);
        setData(response.data.submittedToEngineer);
        setReturnedReports(response.data.returnedReports);
        setMessage("Report Un-Finalized successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);
        // setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.year}/${String(row.id).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: pendingsCreditJobs,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#FAD02C",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
      <MenuItem
        key={2}
        onClick={() => {
          setCheckedReport("APPROVE");
          setConfirmMessage("Are you sure you want to approve the report?");
          setSelectedRequestId(row.original);
          setOpenConfirmDialog(true);
          closeMenu();
        }}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<VerifiedUserSharp color="success" />}
        >
          <Typography variant="subtitle1" color="success">
            Approve Report
          </Typography>
        </Button>
      </MenuItem>,
      <MenuItem
        key={3}
        onClick={() => {
          setCheckedReport("REJECT");
          setConfirmMessage("Are you sure you want to reject the report?");
          setSelectedRequestId(row.original);
          setOpenConfirmDialog(true);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Cancel color="error" />}>
          <Typography variant="subtitle1" color="error">
            Reject Report
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  //---------------------------------------------------------------Returned fro TO / Engineer-------------------------------------------

  //should be memoized or stable
  const columnsReturned = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.year}/${String(row.id).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorKey: "assignUser",
        accessorFn: (row) => `${row.assignUser}`,
        header: "User",
        size: 80,
      },
    ],
    [],
  );

  const tableReturned = useMaterialReactTable({
    columns: columnsReturned,
    data: returnedReports,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true
            ? colors.greenAccent[800]
            : "#ffa3a3cb",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          // console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  //---------------------------------------------------------------Submit by Engineer-------------------------------------------

  //should be memoized or stable
  const columnsSubmitToEng = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        //accessorKey: "institute.instituteName", //access nested data with dot notation
        header: "Job No",
        size: 80,
      },
      {
        accessorKey: "regDate",
        header: "Job Date",
        size: 80,
      },
      {
        accessorKey: "instituteName", //access nested data with dot notation
        header: "Institute / Contractor",
        size: 200,
      },

      {
        accessorFn: (row) =>
          `QC/${row.reportType}/${row.year}/${String(row.id).padStart(4, "0")}`,
        header: "Report No",
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Report Date",
        size: 80,
      },
      {
        accessorKey: "assignUser",
        accessorFn: (row) => `${row.assignUser} `,
        header: "User",
        size: 80,
      },
    ],
    [],
  );

  const tableSubmitToEng = useMaterialReactTable({
    columns: columnsSubmitToEng,
    data: data,

    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows

      sx: {
        padding: "10px",
        backgroundColor:
          row.original.complete === true ? colors.greenAccent[800] : "#ffdb15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.log("daaaa....", row.original);
          setSelectedRequestId(row.original);
          handleOpenReportPreview();
          closeMenu();
        }}
        startIcon={<Receipt color="success" />}
      >
        <Button
          variant="text"
          fullWidth
          startIcon={<Receipt color="success" />}
        >
          <Typography color="success" variant="subtitle1">
            View REPORT
          </Typography>
        </Button>
      </MenuItem>,
      <MenuItem
        key={3}
        onClick={() => {
          unFinalizeSelectedRequestDB(row.labRequestTestsId);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Cancel color="error" />}>
          <Typography variant="subtitle1" color="error">
            Disapprove
          </Typography>
        </Button>
      </MenuItem>,
    ],
  });

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const completeSelectedRequestDB = async () => {
    console.log("object complete job", selectedRequestId);
    setOpenConfirmDialog(false);
    setLoading(true);

    await axios
      .put(
        DATA_SAVE_URL + "/api/v1/labReq/complete" + selectedRequestId.id,
        null,
        {
          params: {
            userId: loggedUser.id,
            assignUser: selectedRequestId.assignUser.id,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then(function (response) {
        // console.log(response.data);
        setOpenConfirmDialog(false);

        setPendingCreditJobsTO(response.data.pendingRequestsTO);
        setPendingCreditJobs(response.data.pendingRequests);
        setData(response.data.submittedToEngineer);
        setReturnedReports(response.data.returnedReports);

        setMessage("Report finalized successfully..!");
        setLoading(false);
        setMessageType("success");
        setOpen(true);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {" "}
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            centered
          >
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Approve Reports"
              {...a11yProps(0)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Submitted to Engineer"
              {...a11yProps(1)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Returned Reports"
              {...a11yProps(2)}
            />
            <Tab
              sx={{ fontSize: "14px", fontWeight: 600 }}
              label="Create Report"
              {...a11yProps(3)}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Paper
            sx={{
              padding: "5px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header
              title="Pending Approvals"
              subtitle="View Report / Approve / Reject"
            />
            <Box display="flex" margin={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Circle sx={{ color: "#FFDB15" }} size="small" />{" "}
                <Typography variant="subtitle1">Pending reports</Typography>
              </Box>
            </Box>
            <MaterialReactTable table={table} />
          </Paper>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Paper
            sx={{
              padding: "5px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header
              title="To be approved by Engineer"
              subtitle="View / Un-Approve Report"
            />
            <MaterialReactTable table={tableSubmitToEng} />
          </Paper>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <Paper
            sx={{
              padding: "5px",
              borderRadius: "8px",
              width: "95%",
              marginTop: "15px",
            }}
            elevation={3}
          >
            <Header title="Returned Reports" subtitle="View Report" />
            <Box display="flex" margin={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Circle sx={{ color: "#ff7575ff" }} size="small" />{" "}
                <Typography variant="subtitle1">
                  All returned reports
                </Typography>
              </Box>
            </Box>
            <MaterialReactTable table={tableReturned} />
          </Paper>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3} centered>
          <Paper
            sx={{ padding: "15px", borderRadius: "8px", width: "95%" }}
            elevation={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Header
                title="Create Report"
                subtitle="Edit report data / Finalize"
              />
              <TextField
                select
                label="Select year"
                size="small"
                value={currentYear}
                onChange={(e) => {
                  setCurrentYear(e.target.value);
                  loadBasicData(e.target.value);
                }}
                sx={{
                  marginBottom: "5px",
                  marginTop: "8px",
                  gridColumn: "span 2",

                  width: "150px",
                }}
              >
                {year?.map((option) => (
                  <MenuItemMui key={option.id} value={option.value}>
                    {option.value}
                  </MenuItemMui>
                ))}
              </TextField>
            </Box>

            {loggedUser.id == 9
              ? pendingsCreditJobsTO?.map((data, index) => (
                  <ToPanelComponent
                    key={index}
                    colors={colors}
                    isNonMobile={isNonMobile}
                    loggedUser={loggedUser}
                    id={data.labRequest.id}
                    year={data.labRequest.year}
                    regDate={data.labRequest.regDate}
                    project={data.labRequest.project}
                    institute={data.labRequest.institute.instituteName}
                    contactNo={data.labRequest.contactNo}
                    contactPerson={data.labRequest.contactPerson}
                    email={data.labRequest.email}
                    grandTotal={data.labRequest.grandTotal}
                    paid={data.labRequest.paid}
                    officers={officers}
                    setOpen={setOpen}
                    setMessage={setMessage}
                    setMessageType={setMessageType}
                    data={data}
                    labTests={data.labRequest.labRequestTests}
                    index={index}
                    setLoading={setLoading}
                    loading={loading}
                    labRequestInvoice={data.labRequest.labRequestInvoice}
                    setOpenConfirmDialog={setOpenConfirmDialog}
                    setSelectedRequestId={setSelectedRequestId}
                    setOpenReportDialog={setOpenReportDialog}
                    setSelectedTest={setSelectedTest}
                    setConfirmMessage={setConfirmMessage}
                    setCheckedReport={setCheckedReport}
                    handleOpenReportPreview={handleOpenReportPreview}
                  />
                ))
              : ""}
          </Paper>
        </CustomTabPanel>
      </Box>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
      <ConfirmationDialog
        confirmationMessage={confirmMessage}
        openConfirmDialog={openConfirmDialog}
        handleCloseDialog={handleCloseDialog}
        messageTitle={
          checkedReport === "APPROVE"
            ? "APPROVE REPORT"
            : checkedReport === false
              ? "FINALIZE REPORT"
              : "REJECT REPORT"
        }
        dialogFunction={
          checkedReport === "APPROVE"
            ? checkedSelectedRequestDB
            : checkedReport === false
              ? completeSelectedRequestDB
              : rejectReport
        }
        setRejectReason={setRejectReason}
      />
      {
        <ReportTypeDialog //data enter panel
          isNonMobile={isNonMobile}
          handleClose={handleCloseReport}
          open={openReportDialog}
          data={selectedRequestId}
          setSelectedRequestId={setSelectedRequestId}
          selectedTest={selectedTest}
          loggedUser={loggedUser}
          setSelectedTest={setSelectedTest}
          setOpenReportDialog={setOpenReportDialog}
        />
      }
      <JobInvoiceDialog
        isNonMobile={isNonMobile}
        colors={colors}
        handleOpenInvoice={handleOpenInvoice}
        handleCloseInvoice={handleCloseInvoice}
        open={openInvoiceDialog}
        data={
          selectedRequestId.labRequest
            ? selectedRequestId.labRequest
            : selectedRequestId
        }
        type={"INVOICE"}
      />
      {/* <ReportDialog //report preview
        colors={colors}
        isNonMobile={isNonMobile}
        handleOpenReportPreview={handleOpenReportPreview}
        handleCloseReportPreview={handleCloseReportPreview}
        open={openReportPreviewDialog}
        data={selectedRequestId}
      /> */}
      <PDFViewerDialog
        reportNo={`QC_${selectedRequestId?.reportType}_${
          selectedRequestId?.labRequest?.year
        }_${String(selectedRequestId?.labRequest?.autoIdByYear).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.barcode}
        open={openReportPreviewDialog}
        handleCloseReportPreview={handleCloseReportPreview}
        reportType={"REPORT"}
        letterHead={true}
      />
    </Box>
  );
};

export default TechnicalOfficer;
